import type { ProfileUserDataDexesTabProps } from './ProfileUserDataDexTab.types';
import type { ReactElement } from 'react';

import { Box, Flex, Grid } from '@rango-dev/whale';
import { Pagination } from '@rango-dev/whale/lab';
import React from 'react';

import usePagination from '../../../../hooks/usePagination';
import { usePaginationLabels } from '../../../../hooks/usePaginationLabels';
import { useWindowDimensions } from '../../../../hooks/useWindowDimensions';
import { ProfileUserDataProtocolCard } from '../PorfileUserDataProtocolCard';
import { ProfileUserDataEmptyState } from '../ProfileUserDataEmptyState';

const GRID_MIN_WIDTH = '300px';
const LOADING_COUNT = 8;

export function ProfileUserDataDexTab(props: ProfileUserDataDexesTabProps): ReactElement {
  const { profileDexes, loading, error } = props;
  const { isMobile } = useWindowDimensions();
  const { paginatedItems, totalPages, page, setPage } = usePagination({
    items: profileDexes ?? [],
  });
  const paginationLabels = usePaginationLabels();

  if (loading) {
    return (
      <Grid
        columns={{ initial: '1', sm: `repeat(auto-fill, minmax(${GRID_MIN_WIDTH}, 1fr))` }}
        gap={{ initial: '4', md: '5' }}>
        {Array.from({ length: LOADING_COUNT }, (_, idx) => idx).map((idx) => (
          <ProfileUserDataProtocolCard type="dex" key={`dex-skeleton-${idx}`} loading />
        ))}
      </Grid>
    );
  }

  if (!profileDexes?.length) {
    return <ProfileUserDataEmptyState error={error} />;
  }

  const itemToRender = isMobile ? profileDexes : paginatedItems;

  return (
    <Flex direction="column" gap="5">
      <Grid
        columns={{ initial: '1', sm: `repeat(auto-fill, minmax(${GRID_MIN_WIDTH}, 1fr))` }}
        gap={{ initial: '4', md: '5' }}>
        {itemToRender.map((profileDexItem) => (
          <ProfileUserDataProtocolCard
            type="dex"
            key={profileDexItem.swapper.title}
            data={profileDexItem}
          />
        ))}
      </Grid>
      {!isMobile && totalPages > 1 ? (
        <Box>
          <Pagination.Set
            showEdgePages
            currentPage={page}
            totalPages={totalPages}
            onPageChange={setPage}
            labels={paginationLabels}
          />
        </Box>
      ) : null}
    </Flex>
  );
}
